import { getSiteVersion } from './env.js';
import { getGpcValue, getDntValue, getCookieValue } from './browser.js';
import { forwardBeacon } from './transporter.js';
const DEFAULT_VISID_COOKIE = 'sfly3_visid';
const STAGE_VISID_COOKIE = 'sfly3_visid_stage';

const consentLogPageId = generateUUID();

export function generateUUID(): string {
  // simple RFC4122 v4 style generator without external dependencies
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const value = c === 'x' ? r : (r & 0x3) | 0x8;
    return value.toString(16);
  });
}

const COOKIE_NAME_BY_ENV: Record<string, string> = {
  dev: 'CognitoIdentityServiceProvider.7jolpe9o8hgbe25vk1j7uushir.LastAuthUser',
  stage:
    'CognitoIdentityServiceProvider.279bgt6gacnhmn9ukgu63qquh3.LastAuthUser',
  prod: 'CognitoIdentityServiceProvider.t8oiif52mece6bleeas2pof0n.LastAuthUser',
};

function prepareLogObject() {
  const email =
    process.env.ENV && getCookieValue(COOKIE_NAME_BY_ENV[process.env.ENV])
      ? getCookieValue(COOKIE_NAME_BY_ENV[process.env.ENV])
      : window?.$sflyAuth?.currentUser?.email;
  const { sfly_uid, user_type } = window?.$sflyAuth?.currentUser || {};
  return [
    {
      startMillis: Date.now(),
      endMillis: Date.now(),
      appName: 'consent-logger',
      serviceLogVersion: 'v2',
      brandId: 'SFLY',
      appContext: {
        metric: 'INFO',
        success: true,
        siteVersion: getSiteVersion(),
        userAgent: window.navigator.userAgent,
        url: window.location.href,
        urlPath: window.location.pathname,
      },
      appVersion: process.env.CI_BUILD_UUID,
      metadata: {
        consentLogPageId,
        visId:
          process.env.ENV === 'stage' && getCookieValue(STAGE_VISID_COOKIE)
            ? getCookieValue(STAGE_VISID_COOKIE)
            : getCookieValue(DEFAULT_VISID_COOKIE),
        gpc: !!getGpcValue(),
        dnt: getDntValue() === '1',
        consentManagerEventType: '',
        email,
        sfly_uid,
        user_type,
      },
    },
  ];
}

export function logError(
  message: string,
  additionalArgs: Record<string, unknown>,
): void {
  try {
    const logObject = prepareLogObject();
    logObject[0].metadata = { ...additionalArgs, ...logObject[0].metadata };
    logObject[0].metadata.consentManagerEventType = message;
    console.error('[consent-logger] logError - ', logObject);
    forwardBeacon(logObject);
  } catch (error) {
    const err = error instanceof Error ? error : new Error(String(error));
    console.error('[consent-logger][logError]', message, additionalArgs, err);
  }
}

export function logEvent(
  message: string,
  additionalArgs: Record<string, unknown>,
): void {
  try {
    const logObject = prepareLogObject();
    logObject[0].metadata = { ...additionalArgs, ...logObject[0].metadata };
    logObject[0].metadata.consentManagerEventType = message;
    console.log('[consent-logger] logEvent', logObject);
    forwardBeacon(logObject);
  } catch (error) {
    const err = error instanceof Error ? error : new Error(String(error));
    console.error('[consent-logger][logEvent]', message, additionalArgs, err);
  }
}
